module.exports = require("./es-UY.d.ts");